import { createContext } from 'react'

const FilterTagsContext = createContext()

export default FilterTagsContext
